export default "__VITE_ASSET__33669a79__"